import {
  Button,
  ButtonProps,
  IconButton,
  IconButtonProps,
  useTheme,
} from '@mui/material';

import { mergeSxProps } from '~/utils/helpers/sxProps';

const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      border: '1px solid #cccccc',
      height: '24px',
      fontSize: '15px',
      borderRadius: '2px',
      color: '#336699',
      fontWeight: 'normal',
      letterSpacing: 'normal',
      backgroundColor: '#e9e9ed',
      fontFamily: 'arial, helvetica, sans-serif',
      textTransform: 'capitalize',
      '&:hover': {
        backgroundColor: '#d0d0d7',
      },
      '& .MuiButton-startIcon': {
        '& .fa': {
          fontSize: 'inherit',
        },
      },
    },
    icon: {
      padding: theme.spacing(1, 0),
      width: '24px',
    },
  };
};

export const LegacyMuiButton = (props: ButtonProps) => {
  const { sx, children, ...rest } = props;
  const sxStyles = useSxStyles();

  return (
    <Button {...rest} sx={mergeSxProps(sxStyles.root, sx)}>
      {children}
    </Button>
  );
};

export const LegacyMuiIconButton = (props: IconButtonProps) => {
  const { sx, ...rest } = props;
  const sxStyles = useSxStyles();

  return (
    <IconButton {...rest} sx={mergeSxProps(sxStyles.root, sxStyles.icon, sx)} />
  );
};
